import React, {useCallback} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import {
  markUpDownContextAction,
  useMarkUpContext
} from "./FeaturesSetupMarkUpContext";
import markUpItemInterface from "./markUpItemInterface";
import SvgIcons from "../../Icons/SvgIcons";
import {toggleArrayObject} from "../../FeatureCreator/FeaturesFilters/filtersFunctions";
import {setQuestionPopupState} from "../../../actions/A_Popups";
import {featuresSetupUpdateFeature} from "../featuresActions";

const FeaturesSetupMarkPopupListItemDeleteButton = (props) => {

  const {markUpListItem, markUpListItemIndex, setQuestionPopupState, featuresAssigned, featuresSetupUpdateFeature,
    intl} = props;
  const {markUpDownContextState, markUpDownContextDispatch} = useMarkUpContext();
  const {markUpList, activeMarkUpItemIndex} = markUpDownContextState;

  const markUpListItemDeleteMarkUpListItem = () => {
    if (featuresAssigned.length) {
      featuresAssigned.forEach(feature => {
        let parsedFeatureLogic = JSON.parse(feature.markUpLogic);
        parsedFeatureLogic = parsedFeatureLogic.filter(markItem => markItem.id !== markUpListItem.id);
        featuresSetupUpdateFeature(feature, "markUpLogic", parsedFeatureLogic);
      })
    }
    if (activeMarkUpItemIndex === markUpListItemIndex) {
      markUpDownContextDispatch(markUpDownContextAction({
        activeMarkUpItemIndex: -1,
      }))
    } else if (activeMarkUpItemIndex > markUpListItemIndex) {
      markUpDownContextDispatch(markUpDownContextAction({
        activeMarkUpItemIndex: activeMarkUpItemIndex - 1,
      }))
    }
    markUpDownContextDispatch(markUpDownContextAction({
      markUpList: toggleArrayObject(markUpList, markUpListItem, "id"),
    }));
  };

  const markUpListItemDeleteClick = useCallback(() => {
    if (featuresAssigned.length) {
      setQuestionPopupState({
        className: "ui-popup--question--with-border",
        showPopup: true,
        questionMessage: intl.formatMessage({id: "features.setup.markUpDownPopup.deleteQuestion"}),
        yesClick: markUpListItemDeleteMarkUpListItem,
        noClick: null,
      })
    } else {
      markUpListItemDeleteMarkUpListItem()
    }
  }, [featuresAssigned, markUpListItem, markUpListItemIndex])

  return (
    <button className="ui-mark-list__item-icon-button" onClick={markUpListItemDeleteClick}>
      {SvgIcons.trashCan}
    </button>
  )
};

FeaturesSetupMarkPopupListItemDeleteButton.propTypes = {
  markUpListItem: PropTypes.shape(markUpItemInterface),
  featuresAssigned: PropTypes.arrayOf(PropTypes.shape(markUpItemInterface)),
}

const mapDispatchToProps = {
  setQuestionPopupState,
  featuresSetupUpdateFeature,
};

export default injectIntl(
  connect(null, mapDispatchToProps)(FeaturesSetupMarkPopupListItemDeleteButton)
)
